import {
    Box,
    Button,
    HStack,
    Image,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    SimpleGrid,
    Spinner,
    Text,
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { Logo } from '../../Utils';
import { fetchInsuranceCategories, fetchInsurances } from '../../api'; // Replace these with your actual API call functions
import PdfGeneratorPsc from '../../components/PdfGeneratorPsc';

const ExportModal = ({ isOpen, onClose }) => {
    const [organizedData, setOrganizedData] = useState([]);
    const [loading, setLoading] = useState(true); // For loading state
    const [error, setError] = useState(null); // For error handling
    const chunkRefs = useRef([]);

    useEffect(() => {
        if (isOpen) {
            fetchAllData();
        }
    }, [isOpen]);

    const fetchAllData = async () => {
        try {
            setLoading(true);
            setError(null); // Reset errors
            // Fetch all insurances and categories without pagination
            const insDataResult = await fetchInsurances(1, 9999);
            const insCatResult = await fetchInsuranceCategories();

            if (insDataResult.success && insCatResult.success) {
                organizeData(insDataResult.data.insurances, insCatResult.data);
            } else {
                throw new Error('Failed to fetch data.');
            }
        } catch (err) {
            setError('Error fetching data: ' + err.message);
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const organizeData = (insData, insCat) => {
        // Organize insurance data by categories and chunk them into pages of 50 items
        const data = insCat.map((category) => {
            const insurances = insData.filter((ins) => ins.category._id === category._id);
            return {
                category,
                chunks: chunkArray(insurances, 48),
            };
        });
        setOrganizedData(data);
        // Create refs for each chunk of category section for PDF generation
        chunkRefs.current = data.flatMap(({ chunks }) => chunks.map(() => React.createRef()));
    };

    // Function to split array into chunks of a given size
    const chunkArray = (arr, chunkSize) => {
        const chunks = [];
        for (let i = 0; i < arr.length; i += chunkSize) {
            chunks.push(arr.slice(i, i + chunkSize));
        }
        return chunks;
    };

    return (<Modal isOpen={isOpen} onClose={onClose} size="6xl">
        <ModalOverlay />
        <ModalContent bg="white" color="black">
            <ModalHeader>
                <PdfGeneratorPsc
                    chunkRefs={chunkRefs}
                    name="Insurance List"
                    title="Download Insurance List"
                />
            </ModalHeader>
            <ModalBody>
                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                        <Spinner size="lg" />
                    </Box>
                ) : error ? (
                    <Text color="red.500">{error}</Text>
                ) : organizedData.length > 0 ? (
                    organizedData.map(({ category, chunks }, categoryIndex) =>
                        chunks.map((chunk, chunkIndex) => (
                            <Box
                                key={`${category._id}-${chunkIndex}`}
                                ref={chunkRefs.current[categoryIndex * organizedData[0].chunks.length + chunkIndex]}
                                mb={8}
                            >
                                {/* Header Box */}
                                <Box bg="blue.900" color="white" p={10} mb={4}>
                                    <HStack>
                                        <Image src={Logo} alt="Logo" boxSize="150px" w={200} objectFit="contain" />
                                        <Box textAlign="center" ml="10%">
                                            <Text fontSize="4xl" fontWeight="bold">{category.name}</Text>
                                            <Text>info@mydlslab.com | +1(888)-882-3330</Text>
                                        </Box>
                                    </HStack>
                                </Box>

                                {/* Data Grid */}
                                <SimpleGrid columns={3} spacing={2} mt={4} px={10}>
                                    {chunk.map((ins) => (
                                        <Box
                                            key={ins._id}
                                            p={4}
                                            borderWidth={1}
                                            borderRadius="md"
                                            borderColor="gray.300"
                                            bg="white"
                                            color="black"
                                        >
                                            <Text fontWeight="bold">{ins.name}</Text>
                                        </Box>
                                    ))}
                                </SimpleGrid>
                            </Box>
                        ))
                    )
                ) : (
                    <Text>No data available to display.</Text>
                )}
            </ModalBody>
            <ModalFooter>
                <Button colorScheme="blue" mr={3} onClick={onClose}>
                    Close
                </Button>
            </ModalFooter>
        </ModalContent>
    </Modal>

    );
};

export default ExportModal;
